import React from 'react';
import { logoArtwork } from '../../data/logoArtwork';
interface LogoLockupProps {
  className?: string;
  /** Trim the white field around the artwork so the lockup takes less vertical room. */
  trimmed?: boolean;
}

/** Full lockup, light variant. Multiply removes the artwork's white field on Paper. */
export function LogoLockup({
  className = '',
  trimmed = false
}: LogoLockupProps) {
  const {
    src,
    alt,
    width,
    height,
    bounds
  } = logoArtwork;
  if (trimmed) {
    const bw = bounds.x2 - bounds.x1;
    const bh = bounds.y2 - bounds.y1;
    return <div className={`overflow-hidden ${className}`} style={{
      aspectRatio: `${bw} / ${bh}`
    }} data-id="element-20" data-mp="1jbj9sxa6pdd9">
        <img src={src} alt={alt} width={width} height={height} draggable={false} decoding="async" className="block h-auto max-w-none select-none" style={{
        mixBlendMode: 'multiply',
        width: `${width / bw * 100}%`,
        marginLeft: `${-bounds.x1 / bw * 100}%`,
        marginTop: `${-bounds.y1 / bw * 100}%`
      }} data-id="element-21" data-mp="14ifyv8r3lxvi" />
      </div>;
  }
  return <div className={className} data-id="element-22" data-mp="2pu6ldifoog09">
      <img src={src} alt={alt} width={width} height={height} draggable={false} decoding="async" className="block h-auto w-full select-none" style={{
      mixBlendMode: 'multiply'
    }} data-id="element-23" data-mp="33k0be42xd6bk" />
    </div>;
}